<ng-template #content let-offcanvas>
  <div class="offcanvas-header align-items-start flex-column">
    <button-component
      class="d-flex align-items-center justify-content-end w-100"
      [config]="configs().btn.closeOffCanvas"
    />
    <div class="d-flex flex-column">
      <span class="offcanvas-title fs-5 fw-bold">
        {{ "app.pageId.transaction-info" | translate }}
      </span>
    </div>
  </div>
  <div class="divider w-100"></div>

  <div class="offcanvas-body">
    @if(headerInfo){
    <section class="d-flex flex-column gap-4">
      <div class="d-flex flex-column gap-4 fw-semibold lh-sm">
        <section class="d-flex flex-column justify-content-end">
          <span class="fs-9 text-uppercase">{{
            headerInfo.requestedCoverage | translate
          }}</span>
          <span class="fs-8 text-info m-0">{{
            "app.pageId.requested-coverage" | translate
          }}</span>
        </section>
        <section class="d-flex flex-column justify-content-end">
          <span class="fs-9">{{
            headerInfo.receptionDate | dynamicMask : "datetime.numeric"
          }}</span>
          <span class="fs-8 text-info m-0">{{
            "app.pageId.reception-date" | translate
          }}</span>
        </section>
        <section class="d-flex flex-column justify-content-end">
          <span class="fs-9">{{ headerInfo.userRepresentative }}</span>
          <span class="fs-8 text-info m-0">{{
            "app.pageId.user/representative" | translate
          }}</span>
        </section>
      </div>
      <create-claim-button-component />
      <void-claim-button-component />
      <create-settlement-button-component />
    </section>
    } @else{
    <section class="d-flex flex-row gap-4 align-items-center placeholder-glow">
      <div class="d-flex flex-row gap-3 text-end">
        <section class="d-flex flex-column justify-content-end fw-bold gap-1">
          <span class="placeholder bg-primary"></span>
          <h6 class="fs-8 text-info fw-medium m-0">
            {{ "app.pageId.requested-coverage" | translate }}
          </h6>
        </section>
        <section class="d-flex flex-column justify-content-end fw-bold gap-1">
          <span class="placeholder bg-primary"></span>
          <h6 class="fs-8 text-info fw-medium m-0">
            {{ "app.pageId.reception-date" | translate }}
          </h6>
        </section>
        <section class="d-flex flex-column justify-content-end fw-bold gap-1">
          <span class="placeholder bg-primary"></span>
          <h6 class="fs-8 text-info fw-medium m-0">
            {{ "app.pageId.user/representative" | translate }}
          </h6>
        </section>
      </div>
    </section>
    }
  </div>
</ng-template>

<nav class="navbar sticky-top bg-white" aria-label="Site menu">
  <div
    class="container-xl container-md container-sm d-flex flex-row justify-content-between p-0"
  >
    <section class="navbar-brand d-flex flex-row gap-2">
      <button-component
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarToggleExternalContent"
        aria-controls="navbarToggleExternalContent"
        [config]="configs().btn.openOffCanvas"
      />
      @if(headerInfo){
      <a
        routerLink="/"
        class="d-flex align-items-center navbar-brand-logo text-decoration-none"
      >
        <img
          alt="Logo"
          [src]="`assets/images/logos/logo-${headerInfo.logo}.webp`"
        />
      </a>
      } @else {
      <section
        class="d-flex flex-row gap-4 align-items-center placeholder-glow"
        style="width: 10vw"
      >
        <span class="placeholder bg-primary p-3 col-12"></span>
      </section>
      }
    </section>
    @if(currentSection){
    <!-- {{ currentSection.content }} -->
    <ng-container
      *ngComponentOutlet="
      currentSection.content;
      inputs: {
        config: currentSection.data.config,
      }
    "
    />
    } @else { @if(headerInfo){
    <section class="d-flex flex-row gap-4 align-items-center">
      <div
        class="d-none d-lg-flex flex-row gap-3 text-end fw-semibold"
        style="line-height: 1.5"
      >
        <section class="d-flex flex-column justify-content-end">
          <span class="fs-7 text-uppercase">{{
            headerInfo.requestedCoverage | translate
          }}</span>
          <span class="fs-8 text-info m-0">{{
            "app.pageId.requested-coverage" | translate
          }}</span>
        </section>
        <section class="d-flex flex-column justify-content-end">
          <span class="fs-7">{{
            headerInfo.receptionDate | dynamicMask : "datetime.numeric"
          }}</span>
          <span class="fs-8 text-info m-0">{{
            "app.pageId.reception-date" | translate
          }}</span>
        </section>
        <section class="d-flex flex-column justify-content-end">
          <span class="fs-7">{{ headerInfo.userRepresentative }}</span>
          <span class="fs-8 text-info m-0">{{
            "app.pageId.user/representative" | translate
          }}</span>
        </section>
      </div>
      <create-claim-button-component />
      <undo-claim-creation-process-button-component />
      <void-claim-button-component />
      <create-settlement-button-component />
    </section>
    } @else{
    <section
      class="d-flex flex-row gap-4 align-items-center placeholder-glow"
      style="width: 30%"
    >
      <span class="placeholder bg-primary p-3 col-12"></span>
    </section>
    <section
      class="d-flex flex-row gap-4 align-items-center placeholder-glow d-none"
    >
      <div class="d-flex flex-row gap-3 text-end">
        <section class="d-flex flex-column justify-content-end fw-bold gap-1">
          <span class="placeholder bg-primary"></span>
          <h6 class="fs-8 text-info fw-medium m-0">
            {{ "app.pageId.requested-coverage" | translate }}
          </h6>
        </section>
        <section class="d-flex flex-column justify-content-end fw-bold gap-1">
          <span class="placeholder bg-primary"></span>
          <h6 class="fs-8 text-info fw-medium m-0">
            {{ "app.pageId.reception-date" | translate }}
          </h6>
        </section>
        <section class="d-flex flex-column justify-content-end fw-bold gap-1">
          <span class="placeholder bg-primary"></span>
          <h6 class="fs-8 text-info fw-medium m-0">
            {{ "app.pageId.user/representative" | translate }}
          </h6>
        </section>
      </div>
    </section>
    } }
  </div>
</nav>
